/* eslint-disable @typescript-eslint/no-explicit-any */
// synergyFetch — client for the-collective-synergy-api (the TCS platform BFF).
// Used by the Leads feature to read marketing-site contact submissions, waitlist
// entries, and discovery-call project briefs. Sends the Watchman bearer token;
// the BFF gates these routes with its role-based CollectiveAdminGuard.
import { useAuthStore } from '../../features/auth/store';
import { getOspreyApiBaseUrl } from './apiBase';

// project-briefs / contact reads go through osprey-api's synergy-proxy, NOT to
// the-collective-synergy-api directly. The Osprey UI never calls synergy-api
// directly — single origin (osprey-api). See apiBase.ts.
const getSynergyBaseUrl = (): string => getOspreyApiBaseUrl();

async function synergyRequest<T = any>(method: string, endpoint: string, data?: any): Promise<T> {
  const baseUrl = getSynergyBaseUrl();
  const headers: HeadersInit = { Accept: 'application/json' };
  if (data !== undefined && method !== 'GET') headers['Content-Type'] = 'application/json';

  const token = useAuthStore.getState().token;
  if (token) headers['Authorization'] = 'Bearer ' + token;

  const config: RequestInit = { method, headers };
  if (data !== undefined && method !== 'GET') config.body = JSON.stringify(data);

  const res = await fetch(baseUrl + endpoint, config);

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    if (res.status === 401) {
      const { logout } = useAuthStore.getState();
      logout();
      if (typeof window !== 'undefined') {
        const currentPath = window.location.pathname + window.location.search;
        window.location.href = '/login?redirect_to=' + encodeURIComponent(currentPath);
      }
    }
    const rawMsg = (err as any).message;
    const message = Array.isArray(rawMsg)
      ? rawMsg[0] || res.statusText || 'Request failed'
      : rawMsg || res.statusText || 'Something went wrong';
    throw { status: res.status, message, fullError: err };
  }

  return res.json();
}

export const SynergyFetch = {
  get: <T = any>(endpoint: string) => synergyRequest<T>('GET', endpoint),
  post: <T = any>(endpoint: string, data?: any) => synergyRequest<T>('POST', endpoint, data),
  patch: <T = any>(endpoint: string, data?: any) => synergyRequest<T>('PATCH', endpoint, data),
};
